import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ResultadoColeta } from '../../comum/modelos/resultado-coleta';
import { ResultadoCriterioColeta } from '../../comum/modelos/resultado-criterio-coleta';

@Component({
    selector: 'app-modal-detalhe-coletas',
    templateUrl: './modal-detalhe-coletas.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./modal-detalhe-coletas.component.css']
})
export class ModalDetalheColetasComponent implements OnInit {

    @Input() resultadoColeta: ResultadoColeta;
    @Input() resultadoCriterioColeta: ResultadoCriterioColeta;

    constructor (private modalService: NgbModal) {
    }

    cadastrar(content) {
        const ngbModalOptions: NgbModalOptions = {
            backdrop: 'static',
            keyboard: false,
            windowClass: 'modalDetalheColetas',
            size: 'lg'
        };
        this.modalService.open(content, ngbModalOptions).result.then((result) => {
        }, (reason) => {
        });
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/coleta/modal-detalhe-coletas/modal-detalhe-coletas.component.ts